/**
 * Current cutover brief, not the frozen historical redirect pack.
 * Public identity and content lookup are deliberately separate.
 * Case-sensitive; LP slash variants redirect to the pair's canonical owner.
 */
export const LEGACY_LP_PRIMARIES = Object.freeze([
  "/lp/rentachevroletcorvette", "/lp/RentaPorsche", "/lp/Boston",
  "/rentafordmustang", "/lp/rentaChevroletCamaro", "/lp/DodgeChallengers",
  "/lp/rentaconvertible", "/lp/MontereyCarRentals", "/lp/datenightcarrentals",
  "/lp/Ferraris", "/lp/FathersDay", "/lp/Rad-rides-for-RADwood",
  "/lp/RentaJaguar",
]);
const byRequest = new Map();
for (const primary of LEGACY_LP_PRIMARIES) {
  const contentPath = primary.replace(/^\/lp(?=\/)/, "");
  const disposition = Object.freeze({ kind: "page", primary, contentPath });
  byRequest.set(primary, disposition);
  byRequest.set(contentPath, disposition);
  byRequest.set(`/lp${contentPath}`, disposition);
  byRequest.set(`/lp${contentPath}/`, Object.freeze({ kind: "redirect", target: primary }));
}
for (const [source, target] of [
  ["/lp/FordThunderbird", "/rentafordthunderbird"],
  ["/lp/Rent", "/rentaclassiccar"],
]) {
  const disposition = Object.freeze({ kind: "redirect", target });
  byRequest.set(source, disposition);
  byRequest.set(source + "/", disposition);
}
export function legacyLpDisposition(pathname) {
  return byRequest.get(pathname) || null;
}
export function legacyLpCanonical(pathname, origin) {
  const disposition = legacyLpDisposition(pathname);
  if (disposition?.kind !== "page") return null;
  let host = "";
  try { host = new URL(origin).hostname.toLowerCase(); } catch { /* Policy probe has no request authority. */ }
  return `${/^(?:www\.)?driveshare\.com$/.test(host)
    ? "https://driveshare.com" : "https://www.bookaclassic.com"}${disposition.primary}`;
}
